import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M15 10h.01","key":"svg-1"}],["path",{"d":"M9.5 15a3.5 3.5 0 0 0 5 0","key":"svg-2"}],["path",{"d":"M8.5 8.5l1.5 1.5l-1.5 1.5","key":"svg-3"}]]

const IconMoodWink = createReactComponent('outline', 'mood-wink', 'MoodWink', __iconNode);

export default IconMoodWink;